// Dependency
import React from 'react';
import Img from "gatsby-image";
import {Swiper, SwiperSlide} from "swiper/react";
import { Link } from "gatsby";

// Components
import TrustBox from "../../trustpilot/trustbox";
import ProductPrice from '../product-price/product-price';
import Video from "../../video";

// Styles
import * as productStyles from "../../../templates/product/product.module.scss";
import * as styles from './bundle-modal.module.scss';

// Internationalization
import { useTranslation } from 'react-i18next';

// Services
import UtilsService from "../../../services/utils.service";

// Template
const BundleModal = ({ productData }) => {

    // Translation Function
    const { t } = useTranslation();

    return (
        <div className={styles.cdBundleModalContainer}>
            <div className={`${styles.cdBundleSwiperWrapper} cd-bundle-swiper`}>
                <Swiper className={`${styles.cdBundleSwiper}`}
                        spaceBetween={24}
                        slidesPerView={2}
                        slidesPerGroup={1}
                        watchSlidesProgress={true}
                        grabCursor={true}
                        navigation={ {
                            nextEl: '.cd-bundle-next',
                            prevEl: '.cd-bundle-prev'
                        }}
                        breakpoints={{
                            900:{
                                spaceBetween: 24,
                                slidesPerView: 2,
                            },
                            0:{
                                spaceBetween: 10,
                                slidesPerView: 2,
                            }
                        }}
                >

                    { productData.datoProduct.gallery && productData.datoProduct.gallery.map( (element, index) => {
                        return (
                            <SwiperSlide key={index.toString()}>
                            <span className={`${styles.cdBundleSwiperImg} cd-background-img`}>
                                {element.isImage === false ?
                                    <Video autoplay={'autoplay'} videoSrcURL={element.url} />
                                    :
                                    <Img fluid={element.fluid} alt={''} />
                                }
                            </span>
                            </SwiperSlide>
                        )
                    }) }
                </Swiper>
                <div className={`${styles.cdBundleModalArrow} ${styles.cdBundleModalArrowRight} cd-swiper-arrows cd-next-arrow cd-bundle-next`} ><div className="cd-arrow"></div></div>
                <div className={`${styles.cdBundleModalArrow} ${styles.cdBundleModalArrowLeft} cd-swiper-arrows cd-prev-arrow cd-bundle-prev`} ><div className="cd-arrow"></div></div>
            </div>

            <div>
                <span className={productStyles.cdSingleProductCat}>{productData.datoProduct.productType}</span>
                <div className={`${productStyles.cdSingleProductContentTop} ${styles.cdBundleModalContent} cd-single-product-top`}>
                    <div>
                        <h1>{productData.datoProduct.title}</h1>
                        {/* <TrustBox
                            locale={productData.locale}
                            templateID={'54d39695764ea907c0f34825'}
                            height={'15px'}
                            width={'220px'}
                            SKU={productData.datoProduct.trustpilotId}
                        /> */}

                    </div>
                    <ProductPrice isVariable={false} priceBeforeDiscount={productData.centraProduct && productData.centraProduct.priceBeforeDiscount}  price={productData.centraProduct && productData.centraProduct.price} />
                </div>
                <div className={styles.cdBundleModalDesc} dangerouslySetInnerHTML={{__html: productData.datoProduct.desc}}></div>
                <div className={productStyles.cdSingleProductContentPerks}>
                    {
                        productData.datoProduct.modalPerks && productData.datoProduct.modalPerks.map( (element) => {
                            return (
                                <div className={productStyles.cdSingleProductContentPerk}>
                                    <i className="material-icons">check</i>
                                    <p>{element.title}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <Link className={`${styles.cdReadMoreButton} button button--outlined button--light`} to={`/${UtilsService.getLocaleFromUrl().country}/${t('slug.product')}/${productData.datoProduct.slug}/`}>{t('productInfo.readMore')}</Link>
        </div>
    )
};

export default BundleModal;